import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import { useAlert, types } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { PageTitle, PaperWithTitle, PagingTable } from '../../../components';
import { useClinicUser, useMaster, usePayment } from '../../../../model/hooks';
import { getLabelPaymentsType, getLabelWorkingDate, isCashOnly, getLabelReward, getLabelPaidReward, isPartTimeOneDay, } from '../../../common/helper';
import { Utils } from '../../../../common/helper';
export const Payment = () => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const { paymentClinic } = useClinicUser();
    const { master } = useMaster();
    const { columns, loadPaymentList, loadingPaymentList } = usePayment();
    const [rows, setRows] = useState([]);
    const loadData = async (lastDocument) => {
        const result = await loadPaymentList(lastDocument);
        return result.data.map((item) => {
            return {
                id: item.id,
                content: item.jobTitle,
                worker: `${item.workerLastName} ${item.workerFirstName}`,
                date: getLabelWorkingDate(item.employmentId, item.startWorkingTimePerDay, item.endWorkingTimePerDay),
                reward: getLabelReward(master.rewardTypeList, item.rewardTypeId, item.rewardAmount),
                paidReward: getLabelPaidReward(item.paidRewardAmount),
                paymentsType: getLabelPaymentsType(master.paymentList, item.payments),
                isCashOnly: isCashOnly(item.payments),
                isPayed: item.isPayed,
                isPartTimeOneDay: isPartTimeOneDay(item.employmentId),
                detail: item,
            };
        });
    };
    const onMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    useEffect(() => {
        const f = async () => {
            try {
                const _rows = await loadData();
                setRows(_rows);
            }
            catch (e) {
                if (e instanceof Error) {
                    reactAlert.show(e.message, { type: types.ERROR });
                }
            }
        };
        if (Utils.isNotNull(paymentClinic) && Utils.isNotNull(master)) {
            f();
        }
    }, [paymentClinic, master]);
    const onClickContent = (id) => {
        var _a;
        const target = rows.find((item) => item.id === id);
        history.push(`/home/job_offer/detail/${(_a = target) === null || _a === void 0 ? void 0 : _a.detail.jobOfferId}`);
    };
    const onClickPayment = (id) => {
        var _a, _b;
        const jobReward = rows.find((item) => item.id === id);
        const jobRewardParam = { ...(_a = jobReward) === null || _a === void 0 ? void 0 : _a.detail.data() };
        history.push('/home/payment/confirm', { jobReward: jobRewardParam, id: (_b = jobReward) === null || _b === void 0 ? void 0 : _b.id });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('支払い処理')),
        React.createElement(SGrid, { container: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: "\u652F\u6255\u3044\u51E6\u7406\u4E00\u89A7" },
                    React.createElement(PagingTable, { columns: columns, rows: rows, loading: loadingPaymentList, onClickContent: onClickContent, onClickExpandMore: onMore, onClickPayment: onClickPayment }))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
